module.exports = __webpack_public_path__ + "assets/img/detail-btn-bcb8dbbc.png";